// Module
var code = "<div :class=\"['instructionButton -download', {'-mac': $attrs.os === 'mac'}]\"> <a target=\"_blank\" v-bind=\"$attrs\"> <slot></slot> </a> </div> ";
// Exports
export default code;